import React from 'react'

import Error from '../landing/error/Error'

const Unauthorized = props => {
  return () => <Error code={401} />
}

export default Unauthorized
